// ============================================================
// ViewModeToggle.jsx
// Floating segmented pill at bottom-center of the canvas area.
// Lets the user flip between 2D editing and 3D preview.
//
// Positioned `absolute` inside the canvas area (App.js's build step),
// so it always sits above whichever canvas is rendered.
// ============================================================

import React from 'react';
import { T } from '../theme';

export default function ViewModeToggle({ mode, onChange }) {
  return (
    <div style={{
      position: 'absolute',
      bottom: 58,                           // clears the 42px canvas bottom toolbar (Snap/Labels/Zoom)
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 100,                          // above canvas, below modals
      display: 'flex',
      background: T.panelBg,                // dark navy, matches dropdown style
      border: T.hairline,
      borderRadius: 24,                     // pill shape
      padding: 4,
      boxShadow: T.shadowMd,
      fontFamily: T.font,
    }}>
      <SegmentButton
        active={mode === '2d'}
        onClick={() => onChange('2d')}
        label="2D"
      />
      <SegmentButton
        active={mode === '3d'}
        onClick={() => onChange('3d')}
        label="3D View"
      />
    </div>
  );
}

// Single segment. Active = navy gradient with white text (matches btnPrimary
// in your theme). Inactive = transparent, reveals the dark pill background.
function SegmentButton({ active, onClick, label }) {
  return (
    <button
      onClick={onClick}
      style={{
        background: active ? T.gradBlue : 'transparent',
        color: active ? '#ffffff' : T.textDim,
        border: 'none',
        padding: '7px 18px',
        borderRadius: 20,
        fontSize: 12,
        fontWeight: active ? 600 : 500,
        cursor: 'pointer',
        fontFamily: 'inherit',
        transition: 'background .12s, color .12s',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </button>
  );
}
